import React from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// widgets
import WarningNotification from '@/widgets/WarningNotification';
import NearExhaustionCampaignsList from '../NearExhaustionCampaignsList';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { Phrases } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
import { IconNotificationWarning } from '@/constants/icons/svg';
// styles
import styles from './BudgetWarning.module.scss';
const BudgetWarning = ({ nearExhaustionCampaigns, onClose, }) => {
    return (React.createElement(WarningNotification, { className: styles.warningNotification, onClose: onClose },
        React.createElement("div", { className: styles.warning },
            React.createElement("div", { className: styles.warningHeader },
                React.createElement(IconNotificationWarning, { fillColor: tokens.colors.yellow3, className: styles.warningIcon }),
                React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.warningHeaderText }, Phrases.HOME_PAGE_BURNOUT_KEYWORD)),
            React.createElement("div", { className: styles.warningContent },
                React.createElement(NearExhaustionCampaignsList, { nearExhaustionCampaigns: nearExhaustionCampaigns })))));
};
export default BudgetWarning;
